<template>
  <div class="flex flex-row justify-center my-4">
    <ButtonContentSection
      :label="label"
      :icon="ChallengesIcon"
      @click="goToCustomChallenge()"
    />
  </div>
</template>
<script setup lang="ts">
import ButtonContentSection from "../layout/button/ButtonContentSection.vue";
import ChallengesIcon from "../icon/ChallengesIcon.vue";

const router = useRouter();

const props = defineProps({
  label: {
    type: String,
  },
  id: {
    type: Number,
  },
  challengeType: {
    type: String,
  },
});

function goToCustomChallenge() {
  if (props.challengeType === "competitive") {
    router.push({
      name: "competitiveChallengeDetail",
      params: {
        challengeId: props.id,
      },
      state: { fromArticle: true },
    });
  } else {
    router.push({
      name: "customChallengeDetail",
      params: {
        challengeId: props.id,
      },
      state: { fromArticle: true },
    });
  }
}
</script>
